import http from '@/http-client'

export const login = data => {
	return http.post('/api/login', data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export default { login}
